import { ArrowUpRight } from "lucide-react";

export const CompanyWebsiteLink = ({ placement, testId, className = "", onClick }) => {
  const url = new URL(process.env.REACT_APP_MAIN_COMPANY_URL);
  url.searchParams.set("utm_source", "atelierdoors");
  url.searchParams.set("utm_medium", "referral");
  url.searchParams.set("utm_campaign", "main_company");
  url.searchParams.set("utm_content", placement);

  return (
    <a
      href={url.toString()}
      target="_blank"
      rel="noopener noreferrer"
      onClick={onClick}
      data-testid={testId}
      title="Viewlux Windows Collection (opens in a new tab)"
      className={`group inline-flex max-w-full items-center justify-center gap-2 rounded-full border border-brand-gold/60 text-brand-gold hover:bg-brand-gold hover:text-brand-green focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-brand-gold transition-colors duration-200 ${className}`}
    >
      <span>Viewlux Windows Collection</span>
      <ArrowUpRight size={16} aria-hidden="true" className="shrink-0 transition-transform duration-200 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
    </a>
  );
};